(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yunic-mobile-more"] && !Shopify.designMode) return;
  try {
    function initializeYunicMore() {
    const panel = document.getElementById('mobile-pageaccount');
    const trigger = document.querySelector('[data-target="#mobile-pageaccount"]');
    if (!panel || !trigger) return;
    const closeButton = panel.querySelector('.close-box');
    trigger.setAttribute('aria-controls', panel.id);
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.addEventListener('click', () => {
      requestAnimationFrame(() => {
        const isOpen = panel.classList.contains('active');
        trigger.setAttribute('aria-expanded', String(isOpen));
        if (isOpen) closeButton.focus();
      });
    });
    closeButton.addEventListener('click', () => {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    });
    document.addEventListener('keydown', (event) => {
      if (!panel.classList.contains('active')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeButton.click();
      } else if (event.key === 'Tab') {
        const controls = Array.from(panel.querySelectorAll('a[href], button, summary')).filter((element) => element.getClientRects().length && !element.disabled);
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeYunicMore, { once: true });
  } else {
    initializeYunicMore();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yunic-product-gallery-arrows"] && !Shopify.designMode) return;
  try {
    (function () {
    function setupGalleryArrows() {
      var labels = document.getElementById('yunic-gallery-labels');
      var $ = window.jQuery;
      if (!labels || !$ || !$.fn.slick) return;
      $('.product-single__photos').each(function () {
        var $photos = $(this);
        var $main = $photos.find('.FeaturedImage_slick').first();
        var $thumbs = $photos.find('#productThumbs .thumb_slick').first();
        var $row = $thumbs.parent();
        if (!$main.length || !$thumbs.length || $row.hasClass('yunic-gallery-nav')) return;
        function addControls() {
          var slider = $main.slick('getSlick');
          if (slider.slideCount < 2 || $row.hasClass('yunic-gallery-nav')) return;
          function makeButton(direction, path) {
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'yunic-gallery-arrow yunic-gallery-' + direction;
            button.setAttribute('aria-label', labels.getAttribute('data-' + direction));
            var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('viewBox', '0 0 24 24');
            svg.setAttribute('aria-hidden', 'true');
            svg.setAttribute('focusable', 'false');
            var line = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            line.setAttribute('d', path);
            svg.appendChild(line);
            button.appendChild(svg);
            return button;
          }
          var previous = makeButton('previous', 'M15 5l-7 7 7 7');
          var next = makeButton('next', 'M9 5l7 7-7 7');
          $row.addClass('yunic-gallery-nav');
          $row.prepend(previous).append(next);
          previous.addEventListener('click', function () { $main.slick('slickPrev'); });
          next.addEventListener('click', function () { $main.slick('slickNext'); });
          $thumbs.find('.thumbItem a').each(function (index) {
            this.setAttribute('aria-label', labels.getAttribute('data-view').replace('[number]', index + 1));
            this.addEventListener('keydown', function (event) {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                $main.slick('slickGoTo', index);
              }
            });
          });
          function updateControls(event, slick, position) {
            var current = typeof position === 'number' ? position : $main.slick('slickCurrentSlide');
            previous.disabled = current === 0;
            next.disabled = current === slider.slideCount - 1;
            $thumbs.find('.thumbItem a').each(function (index) {
              this.setAttribute('aria-current', index === current ? 'true' : 'false');
            });
          }
          $main.on('afterChange.yunicGallery reInit.yunicGallery', updateControls);
          updateControls();
          if ($thumbs.hasClass('slick-initialized')) $thumbs.slick('setPosition');
          else $thumbs.one('init.yunicGallery', function () {
            window.requestAnimationFrame(function () { $thumbs.slick('setPosition'); });
          });
        }
        if ($main.hasClass('slick-initialized')) addControls();
        else $main.one('init.yunicGallery', function () { window.requestAnimationFrame(addControls); });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupGalleryArrows);
    else setupGalleryArrows();
    window.addEventListener('load', setupGalleryArrows, { once: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
